import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/Button';
import { Card } from '@/components/Card';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

/**
 * Contact Support
 *
 * BugHerd #152: /contact was a bare "Contact Support - Coming Soon" div, reached from the
 * principal Contact Support call to action on the requester dashboard.
 *
 * Direct contact channels are not built. A ticket is the contact channel that actually
 * exists today, so that leads here, followed by the ticket list - which is where a reply
 * arrives, and therefore the real conversation thread.
 *
 * Deliberately makes no claim about response times or availability; the only commitments
 * stated are ones the product can currently keep.
 */
export function ContactSupport() {
  useDocumentTitle('Contact Support | SupportDesk');

  return (
    <div className="p-6">
      <div className="max-w-2xl">
        <div className="flex flex-wrap items-center gap-3 mb-2">
          {/* Matches the dashboard call-to-action label exactly so the destination
              identifies itself consistently with the control that leads to it. */}
          <h1 className="text-3xl font-bold text-gray-900">Contact Support</h1>
        </div>

        <p className="text-gray-600 mb-6">
          To reach the support team,
          create a ticket. The team replies on the ticket itself.
        </p>

        <Card className="p-6">
          <div className="flex flex-col sm:flex-row gap-3">
            <Link to="/tickets/new" className="sm:w-auto">
              <Button variant="primary" fullWidth>
                Create a Support Ticket
              </Button>
            </Link>
            <Link to="/tickets" className="sm:w-auto">
              <Button variant="outline" fullWidth>
                View your tickets
              </Button>
            </Link>
          </div>

          <p className="text-sm text-gray-500 mt-4">
            Looking for an answer first?{' '}
            <Link to="/knowledge-base" className="text-primary-600 hover:text-primary-700 underline">
              Browse the Knowledge Base
            </Link>
            .
          </p>
        </Card>
      </div>
    </div>
  );
}
